import type { EditorThemeClasses } from 'lexical';

export const telegramEditorTheme: EditorThemeClasses = {
  // Root
  root: 'tg-editor-root',
  paragraph: 'tg-paragraph',

  // Text formats (mapped via FORMAT_TEXT_COMMAND)
  text: {
    bold: 'tg-bold',
    italic: 'tg-italic',
    underline: 'tg-underline',
    strikethrough: 'tg-strikethrough',
    code: 'tg-inline-code',
  },

  // Built-in block nodes
  quote: 'tg-blockquote',
  code: 'tg-code-block',
  codeHighlight: {
    atrule: 'tg-code-attr',
    attr: 'tg-code-attr',
    boolean: 'tg-code-boolean',
    builtin: 'tg-code-builtin',
    cdata: 'tg-code-comment',
    char: 'tg-code-char',
    class: 'tg-code-class',
    'class-name': 'tg-code-class',
    comment: 'tg-code-comment',
    constant: 'tg-code-constant',
    deleted: 'tg-code-deleted',
    doctype: 'tg-code-comment',
    entity: 'tg-code-entity',
    function: 'tg-code-function',
    important: 'tg-code-important',
    inserted: 'tg-code-inserted',
    keyword: 'tg-code-keyword',
    namespace: 'tg-code-namespace',
    number: 'tg-code-number',
    operator: 'tg-code-operator',
    prolog: 'tg-code-comment',
    property: 'tg-code-property',
    punctuation: 'tg-code-punctuation',
    regex: 'tg-code-regex',
    selector: 'tg-code-selector',
    string: 'tg-code-string',
    symbol: 'tg-code-symbol',
    tag: 'tg-code-tag',
    url: 'tg-code-url',
    variable: 'tg-code-variable',
  },

  // Built-in inline nodes
  link: 'tg-link',

  // Custom nodes
  spoiler: 'tg-spoiler',
  expandableQuote: 'tg-expandable-quote',
  customEmoji: 'tg-custom-emoji',

  // List (used in editor, converted to text on export)
  list: {
    nested: { listitem: 'tg-list-nested' },
    ol: 'tg-list-ol',
    ul: 'tg-list-ul',
    listitem: 'tg-list-item',
  },
};
